// extracted by mini-css-extract-plugin
export default {"spin":"style_spin__JO5hv","spin_anim":"style_spin_anim__MZozA"};